import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'
import { subscriptionParser } from './parsers/subscriptionParser'

const responseParser = (data: any) => {
  const respData = subscriptionParser(data)
  return respData
}

const getSubscriptions = (req: any, tokens: any, userAccessToken: string) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.getSubscriptions,
    method: 'POST',
    cache: false,
    body: req,
    headers: {
      Authorization: userAccessToken,
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { getSubscriptions }
